const PROPERTY_DELETED = '_jsondiff_del';

export const patch = (source, diff) => {

  const next = { ...source };

  Object.entries(diff).forEach(
    ([n, i]) => {
      if (i === PROPERTY_DELETED) {
        delete next[n];
      }
      else if (typeof(i) === 'object') {
        if (Array.isArray(i) || i === null) {
          next[n] = i;
        }
        else if (i.__jsondiff_t === 'a') {
          next[n] = patchArray(source[n], i);
        }
        else {
          const r = source ? source[n] || undefined : undefined;
          if (typeof(r) === 'object') {
            next[n] = patch(r, i);
          }
          else {
            next[n] = i;
          }
        }
      }
      else {
        next[n] = i;
      }
    }
  );


  return next;
};

const patchArray = (source, diff) => {

  let next = [];

  if (!Array.isArray(source)) {
    throw new Error({ 'message': 'patchArray called with non-array source', source });
  }
  else {
    next = [...source];
  }


  const updates = diff.u || {};
  Object.entries(updates).forEach(
    ([n, i]) => {
      if (typeof(i) === 'object') {
        if (i.__jsondiff_t === 'a') {
          next[n] = patchArray(source[n], i);
        }
        else {
          next[n] = patch(source[n], i);
        }
      }
      else {
        next[n] = i;
      }
    }
  );

  (diff.i || []).forEach(
    insertee => {
      next.push(insertee);
    }
  );

  return next;

};


const DICTIONARY_SIZE = 256;
const DICTIONARY = {};

for (let i = 0; i < DICTIONARY_SIZE; i++) {
  DICTIONARY[i] = String.fromCharCode(i);
}

export function lzwDecode(i) {
  // Implementation taken direct from https://racing.liveresults.swisstiming.com/index.js
  // which had changed from the original
  for (var a = i.length, f = [], l = 0;
    l < a;
    l++)f.push(i[l].charCodeAt(0));
  var c, u, h, d = [], p = "", b = 256;
  for (l = 0;
    l < 256;
    l += 1)d[l] = String.fromCharCode(l);
  for (u = c = String.fromCharCode(f[0]), l = 1;
    l < f.length;
    l += 1)u += p = d[h = f[l]] ? d[h] : h === b ? c + c.charAt(0) : String.fromCharCode(h), d[b++] = c + p.charAt(0), c = p;
  return u
}
